import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { OrderDataImportContainer } from '@/components/screens/order-matching/order-data-import-container'
import { ErrorPanel } from '@/components/ui/error-panel'
import { useMe } from '@/providers/me-context'

export const Route = createFileRoute('/t/$tenant_id/order_matching/import')({
  component: Page,
})

function Page() {
  const { tenant_id: tenantId } = Route.useParams()
  const me = useMe()
  const navigate = useNavigate()

  // メニュー非表示でも URL 直打ちで到達できるため、一覧 route と同じく機能フラグを確認する
  if (me.tenant.setting?.orderMatchingEnabled !== true) {
    return (
      <div className="flex min-h-screen">
        <AppSidebarContainer tenantId={tenantId} />
        <main className="flex min-w-0 flex-1 items-center justify-center">
          <ErrorPanel
            layout="section"
            title="発注照合機能が有効になっていません"
            description="ご利用のテナントでは発注照合機能が利用できません。利用をご希望の場合は運営までお問い合わせください。"
          />
        </main>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1 overflow-x-hidden">
        <div className="mx-auto max-w-[1600px] px-6 py-6 lg:px-8">
          <OrderDataImportContainer
            key={tenantId}
            onNavigateToList={() => {
              void navigate({ to: '/t/$tenant_id/order_matching', params: { tenant_id: tenantId } })
            }}
            onOpenImportHistory={() => {
              void navigate({
                to: '/t/$tenant_id/order_matching',
                params: { tenant_id: tenantId },
                search: { tab: 'history' },
              })
            }}
          />
        </div>
      </main>
    </div>
  )
}
